import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ModalModule } from '../../../core/modal/modal.module';
import { SharedModule } from '../../../shared/shared.module';
import { PaymentMethod } from './payment-method.type';
import { PAYMENT_METHODS } from './payment-method.config';
import { PaymentAccountModalService } from '../payment-account-modal.service';

@Component({
  selector: 'tax-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    NgIf,
    TranslateModule,
    FormsModule,
    SharedModule,
  ],
})

export class PaymentMethodComponent {
  @Input() billingAccountNumber = '';
  activePaymentMethod: PaymentMethod = PAYMENT_METHODS[0];
  readonly paymentMethods: PaymentMethod[] = PAYMENT_METHODS;

  constructor(private paymentAccountModalService: PaymentAccountModalService) {}

  selectPaymentMethod(method: PaymentMethod): void {
    this.activePaymentMethod = method;
  }

  openPayment(): void {
    if (this.activePaymentMethod?.byQrcode) {
      this.paymentAccountModalService.openQrcodeModal(
        this.billingAccountNumber,
        this.activePaymentMethod?.qrcodeConfig?.qrCodeStartData,
        this.activePaymentMethod?.qrcodeConfig?.name,
      );
    } else {
      this.paymentAccountModalService.openSupplementModal(this.billingAccountNumber);
    }
  }
}
